import { render, staticRenderFns } from "./qualityManageDetail.vue?vue&type=template&id=b775a50a&scoped=true&"
import script from "./qualityManageDetail.vue?vue&type=script&lang=js&"
export * from "./qualityManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./qualityManageDetail.vue?vue&type=style&index=0&id=b775a50a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b775a50a",
  null
  
)

export default component.exports